// extracted by mini-css-extract-plugin
export default {"row":"ReplyChips_row__KLyYe","list":"ReplyChips_list__Y85kb","chip":"ReplyChips_chip__RO7jW"};